// extracted by mini-css-extract-plugin
export default {"secondSection":"style_secondSection__nmEuN","titles":"style_titles__QSINH","arrowWrapper":"style_arrowWrapper__9jae9","carsWrapper":"style_carsWrapper__6Do2N"};